import { render, staticRenderFns } from "./WorkerLicenseDialog.vue?vue&type=template&id=b5cdb440"
import script from "./WorkerLicenseDialog.vue?vue&type=script&lang=js"
export * from "./WorkerLicenseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports